import store from "@/store/store";

export function wrapService(service) {
  return new Proxy(service, {
    get(target, prop) {
      if (typeof target[prop] === "function") {
        return async (...args) => {
          try {
            store.dispatch("startLoading");
            const result = await target[prop].apply(target, args);
            return result;
          } finally {
            store.dispatch("stopLoading");
          }
        };
      }
      return target[prop];
    },
  });
}
